import Unsubsribe from 'pages/Temporary/Unsubsribe'
import { lazy } from 'react'
import { Redirect, Route } from 'react-router-dom'

const BorrowerAmortizationSchedule = lazy(
  () => import('pages/Borrower/AmortizationSchedule/BorrowerAmortizationSchedule'),
)
const BorrowerLoanOptonsReview = lazy(() => import('pages/Borrower/LoanOptionsReview/BorrowerLoanOptonsReview'))
const BorrowerBudgetScopeOfWork = lazy(() => import('pages/Borrower/BudgerScopeOfWork/BorrowerBudgetScopeOfWork'))
const BorrowerConstructionLedger = lazy(() => import('pages/Borrower/ConstructionLedger/BorrowerConstructionLedger'))
const BorrowerDrawRequest = lazy(() => import('pages/Borrower/DrawRequest/BorrowerDrawRequest'))
const SignLienWaiver = lazy(() => import('pages/Borrower/DrawRequest/SignLienWaiver'))
const AcknowledgeDrawApproval = lazy(() => import('pages/Borrower/DrawRequest/AcknowledgeDrawApproval'))
const Parties = lazy(() => import('pages/Loan/Parties/index'))
const BorrowerEditProfile = lazy(() => import('pages/Borrower/EditProfile/EditProfile'))
const BorrowerLoanApplication = lazy(() => import('pages/Borrower/Application/BorrowerLoanApplication'))
const BorrowerLoanOverview = lazy(() => import('pages/Borrower/LoanOverview/BorrowerLoanOverview'))
const BorrowerLoanSubmission = lazy(() => import('pages/Borrower/Submission/BorrowerLoanSubmission'))
const BorrowerPipeline = lazy(() => import('pages/Borrower/Pipeline/BorrowerPipeline'))
const BorrowerPortalAs = lazy(() => import('pages/Borrower/PortalAs/BorrowerPortalAs'))
const BorrowerServicingDetail = lazy(() => import('pages/Borrower/Servicing/BorrowerServicingDetail'))
const InvestorEditProfile = lazy(() => import('pages/Investor/EditProfile/EditProfile'))
const InvestorLoanOverview = lazy(() => import('pages/Investor/LoanOverview/InvestorLoanOverview'))
const InvestorPipeline = lazy(() => import('pages/Investor/Pipleline/InvestorPipeline'))
const ParticipantPortfolio = lazy(() => import('pages/Participants/Portal/ParticipantPortfolio'))
const ParticipantLoanDetail = lazy(() => import('pages/Participants/Portal/ParticipantLoanDetail'))
const ParticipantDistributions = lazy(() => import('pages/Participants/Portal/ParticipantDistributions'))
const ParticipantDocuments = lazy(() => import('pages/Participants/Portal/ParticipantDocuments'))
const ParticipantProfile = lazy(() => import('pages/Participants/Portal/ParticipantProfile'))
const InvestorPortalFunds = lazy(() => import('pages/Participants/Portal/InvestorFunds'))
const InvestorOnboardingStart = lazy(() => import('pages/InvestorOnboarding/InvestorOnboardingStart'))
const InvestorOnboarding = lazy(() => import('pages/InvestorOnboarding/InvestorOnboarding'))
const InvestorPortalPurchases = lazy(() => import('pages/Participants/Portal/InvestorPurchases'))
const BorrowerEditBudget = lazy(() => import('pages/Loan/Budget/BorrowerEditBudget'))
const CustomSignDocumentGenie = lazy(() => import('pages/Loan/DocumentGenie/CustomSignDocumentGenie'))
const LoanServicingExtensionSign = lazy(() => import('pages/Loan/Servicing/LoanExtension/LoanServicingExtensionSign'))
const OrderValuationFeasibilitySign = lazy(() => import('pages/Loan/OrderAppraisals/FeasibilitySign'))
const PurchaseAdviceSellerSign = lazy(
  () => import('pages/Loan/PostClosing/PurchaseAdviceSeller/PurchaseAdviceSellerSign'),
)
const SignClosingCalendar = lazy(() => import('pages/Loan/ClosingCalendar/SignClosingCalendar'))
const CustomMemberSignApplication = lazy(
  () => import('pages/LoanApplication/AdditionalMember/CustomMemberSignApplication'),
)
const AssetInformationVerificationPage = lazy(
  () => import('pages/LoanApplication/AssetInformation/AssetInformationVerificationPage'),
)
const CustomSignApplication = lazy(() => import('pages/LoanApplication/CustomSignApplication/index'))
const SignLoanTermSheet = lazy(() => import('pages/LoanStructure/SignLoanTermSheet'))
const BrokerVerificationForUser = lazy(() => import('pages/ManageAccounts/BrokerVerificationForUser'))
const MakePaymentPage = lazy(() => import('pages/Payment/MakePaymentPage'))
const ContractorSignApplication = lazy(() => import('pages/Temporary/ContractorSignApplication'))
const SurveyPage = lazy(() => import('pages/Temporary/Survey/index'))
const TrustLedgerAgreement = lazy(() => import('pages/Temporary/TrustLedgerAgreement/index'))
const TextMessageOptIn = lazy(() => import('pages/Temporary/TextMessageOptIn/index'))

const BorrowerCreateLoan = lazy(() => import('pages/Borrower/CreateLoan/BorrowerCreateLoanByConfig'))
const BorrowerApplyAssistant = lazy(() => import('pages/Borrower/ApplyAssistant/BorrowerApplyAssistant'))
const LoanStructurePrint = lazy(() => import('pages/LoanStructure/LoanStructurePrint'))

export const TemporaryRoute = [
  <Route exact path="/borrowerlogin" key={0}>
    <BorrowerPipeline />
  </Route>,
  <Route exact path="/borrowerPipelines" key={0}>
    <BorrowerPipeline />
  </Route>,
  <Route exact path="/borrowerPipelines/:token" key={0}>
    <BorrowerPipeline />
  </Route>,
  <Route exact path="/borrowerPortalAs/:token" key={0}>
    <BorrowerPortalAs />
  </Route>,
  <Route exact path="/borrowerPipeline/overview/:loanNumber" key={0}>
    <BorrowerLoanOverview />
  </Route>,
  <Route exact path="/borrowerPipeline/application/:loanNumber" key={0}>
    <BorrowerLoanApplication />
  </Route>,
  <Route exact path="/borrowerPipeline/submit/:loanNumber" key={0}>
    <BorrowerLoanSubmission />
  </Route>,
  // The signed-in borrower's assistant. Gated per company by the borrower_ai_assistant feature,
  // which is what shows the Quick Link; the route itself is harmless without it.
  <Route exact path="/borrowerPipeline/assistant/:loanNumber" key={0}>
    <BorrowerApplyAssistant signedIn />
  </Route>,
  <Route exact path="/borrowerPipeline/assistant" key={0}>
    <BorrowerApplyAssistant signedIn />
  </Route>,
  // Applying by conversation, for someone who has no account yet. The same application the form at
  // /new fills in, and either one can finish it.
  <Route exact path="/apply" key={0}>
    <BorrowerApplyAssistant />
  </Route>,
  <Route exact path="/borrowerPipeline/budget/:loanNumber" key={0}>
    <BorrowerBudgetScopeOfWork />
  </Route>,
  <Route exact path="/borrowerPipeline/assetInformationVerification/:loanNumber" key={11}>
    <AssetInformationVerificationPage />
  </Route>,
  <Route exact path="/borrowerPipeline/amortizationSchedule/:loanNumber" key={11}>
    <BorrowerAmortizationSchedule />
  </Route>,
  <Route exact path="/borrowerPipeline/drawRequest/:loanNumber" key={11}>
    <BorrowerDrawRequest />
  </Route>,
  <Route exact path="/borrowerPipeline/drawRequest/:token/:loanNumber" key={11}>
    <BorrowerDrawRequest />
  </Route>,
  <Route exact path="/borrowerPipeline/constructionLedger/:loanNumber" key={11}>
    <BorrowerConstructionLedger />
  </Route>,
  <Route exact path="/borrowerPipeline/loanOptionsReview/:loanNumber" key={11}>
    <BorrowerLoanOptonsReview />
  </Route>,
  <Route exact path="/borrowerPipeline/editProfile" key={11}>
    <BorrowerEditProfile />
  </Route>,

  // The standalone servicing card list is retired - the borrower pipeline lists every loan,
  // serviced ones included. Kept as a redirect so an old bookmark still lands somewhere.
  <Route exact path="/borrowerPipeline/servicing" key={24}>
    <Redirect to="/borrowerPipelines" />
  </Route>,
  <Route exact path="/borrowerPipeline/servicing/:loanNumber" key={25}>
    <BorrowerServicingDetail />
  </Route>,

  <Route exact path="/borrowerPipeline/parties/:loanNumber" key={11}>
    <Parties />
  </Route>,

  <Route exact path="/customSignApplication/:token/:loanNumber" key={0}>
    <CustomSignApplication />
  </Route>,
  <Route exact path="/customSignDocumentGenie/:token/:loanNumber" key={1}>
    <CustomSignDocumentGenie />
  </Route>,
  <Route exact path="/brokerVerification/:token" key={2}>
    <BrokerVerificationForUser />
  </Route>,
  <Route exact path="/customMemberSignApplication/:urlSignature/:token/:loanNumber" key={3}>
    <CustomMemberSignApplication />
  </Route>,
  <Route exact path="/orderValuationFeasibilitySign/:id/:token/:loanNumber" key={4}>
    <OrderValuationFeasibilitySign />
  </Route>,
  <Route exact path="/purchaseAdviceSellerSign/:id/:token/:loanNumber" key={5}>
    <PurchaseAdviceSellerSign />
  </Route>,
  <Route exact path="/budget/:urlSignature/:token/:loanNumber" key={6}>
    <BorrowerEditBudget />
  </Route>,
  <Route exact path="/lienWaiver/:urlSignature/:token/:loanNumber" key={23}>
    <SignLienWaiver />
  </Route>,
  <Route exact path="/drawApproval/:urlSignature/:token/:id/:loanNumber" key={136}>
    <AcknowledgeDrawApproval />
  </Route>,
  <Route exact path="/trustLedgerAgreement/:urlSignature/:token/:orderID/:loanNumber" key={7}>
    <TrustLedgerAgreement />
  </Route>,
  <Route exact path="/loanServicingExtension/:id/:token/:loanNumber" key={8}>
    <LoanServicingExtensionSign />
  </Route>,
  <Route exact path="/contractorSignApplication/:urlSignature/:token/:no/:loanNumber" key={9}>
    <ContractorSignApplication />
  </Route>,
  <Route exact path="/makePayment/:token/:loanNumber" key={10}>
    <MakePaymentPage />
  </Route>,
  <Route exact path="/assetInformationVerification/:token/:loanNumber" key={11}>
    <AssetInformationVerificationPage />
  </Route>,
  <Route exact path="/survey/:token/:loanNumber" key={12}>
    <SurveyPage />
  </Route>,
  <Route exact path="/textMessageOptIn/:token/:loanNumber" key={12}>
    <TextMessageOptIn />
  </Route>,
  <Route exact path="/signLoanTermSheet/:token/:loanNumber" key={13}>
    <SignLoanTermSheet />
  </Route>,
  <Route exact path="/signClosingCalendar/:token/:loanNumber" key={14}>
    <SignClosingCalendar />
  </Route>,
  <Route exact path="/investorPipelines" key={15}>
    <InvestorPipeline />
  </Route>,
  <Route exact path="/investorPipelines/:token" key={16}>
    <InvestorPipeline />
  </Route>,
  <Route exact path="/investorEditProfile" key={17}>
    <InvestorEditProfile />
  </Route>,
  <Route exact path="/investorPipeline/overview/:loanNumber" key={18}>
    <InvestorLoanOverview />
  </Route>,

  // Investor onboarding. Public: an applicant is not an investor yet and has nothing to sign in
  // to. The token in the second route IS the credential, so it must stay below the bare path.
  <Route exact path="/investorOnboarding" key={40}>
    <InvestorOnboardingStart />
  </Route>,
  <Route exact path="/investorOnboarding/:token" key={41}>
    <InvestorOnboarding />
  </Route>,

  // The investor portal. One login covering everything an investor holds: slices of serviced loans,
  // loans offered to them to buy, and capital in a mortgage fund.
  <Route exact path="/investorPortal" key={30}>
    <ParticipantPortfolio />
  </Route>,
  <Route exact path="/investorPortal/loan/:loanNumber" key={32}>
    <ParticipantLoanDetail />
  </Route>,
  <Route exact path="/investorPortal/distributions" key={33}>
    <ParticipantDistributions />
  </Route>,
  <Route exact path="/investorPortal/funds" key={36}>
    <InvestorPortalFunds />
  </Route>,
  <Route exact path="/investorPortal/purchases" key={37}>
    <InvestorPortalPurchases />
  </Route>,
  <Route exact path="/investorPortal/purchases/:loanNumber" key={38}>
    <InvestorLoanOverview />
  </Route>,
  <Route exact path="/investorPortal/documents" key={34}>
    <ParticipantDocuments />
  </Route>,
  <Route exact path="/investorPortal/profile" key={35}>
    <ParticipantProfile />
  </Route>,
  // `:token` last, so it cannot swallow the named screens above.
  <Route exact path="/investorPortal/:token" key={31}>
    <ParticipantPortfolio />
  </Route>,

  // What the portal used to be called. Every welcome e-mail ever sent points here.
  <Route exact path="/participantPipelines" key={130}>
    <ParticipantPortfolio />
  </Route>,
  <Route exact path="/participantPipelines/:token" key={131}>
    <ParticipantPortfolio />
  </Route>,
  <Route exact path="/participantPortal/loan/:loanNumber" key={132}>
    <ParticipantLoanDetail />
  </Route>,
  <Route exact path="/participantPortal/distributions" key={133}>
    <ParticipantDistributions />
  </Route>,
  <Route exact path="/participantPortal/documents" key={134}>
    <ParticipantDocuments />
  </Route>,
  <Route exact path="/participantPortal/profile" key={135}>
    <ParticipantProfile />
  </Route>,

  <Route exact path="/unsubscribe/:token" key={19}>
    <Unsubsribe />
  </Route>,

  <Route exact path="/new/:token/:loanNumber" key={20}>
    <BorrowerCreateLoan />
  </Route>,

  <Route exact path="/loan_process/structurePrint/:loanNumber/:token" key={21}>
    <LoanStructurePrint />
  </Route>,
  // Legacy broker "Upload Documents" links. The token in the path used to sign the visitor in
  // automatically, so anyone forwarded the email could upload without authenticating. Links
  // already sent are honored by sending the broker to the authenticated submission screen, which
  // bounces them to the login page when they are not signed in.
  <Route
    exact
    path="/documentSubmission/:token/:loanNumber"
    key={22}
    render={({ match }) => <Redirect to={`/loan_process/submit/${match.params.loanNumber}`} />}
  />,
]
